import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AnimalSymbol from "@/components/AnimalSymbol";
import { useAuth, formatApiError } from "@/contexts/AuthContext";

export default function LoginPage() {
  const nav = useNavigate();
  const loc = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      const dest = loc.state?.from || "/";
      nav(dest === "/login" ? "/" : dest, { replace: true });
    } catch (e2) {
      setErr(formatApiError(e2));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--app-bg)] p-6">
      <div className="w-full max-w-sm bg-white border border-[var(--app-border)] rounded-lg p-8 shadow-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-md bg-[var(--app-bg)] border border-[var(--app-border)] flex items-center justify-center">
            <AnimalSymbol parts={{ ears: "correct", head: "correct", neck: "correct", front: "correct", back: "correct", rear: "correct", tail: "correct" }} size={32} />
          </div>
          <div className="leading-tight">
            <div className="font-display font-extrabold text-lg tracking-tight">Vitality Pedigree</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--app-text-soft)]">Sign in</div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-3" data-testid="login-form">
          <div>
            <Label className="text-xs uppercase tracking-wider text-[var(--app-text-soft)]" htmlFor="email">Email</Label>
            <Input id="email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-[var(--app-text-soft)]" htmlFor="password">Password</Label>
            <Input id="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
          </div>
          {err && <div className="text-sm text-red-600" data-testid="login-error">{err}</div>}
          <Button type="submit" disabled={busy} className="w-full bg-blue-600 hover:bg-blue-700" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <div className="mt-3 text-right">
          <Link to="/forgot-password" className="text-xs text-[var(--app-text-soft)] hover:text-blue-600 hover:underline" data-testid="link-forgot">
            Forgot your password?
          </Link>
        </div>

        <div className="mt-5 text-center text-sm text-[var(--app-text-soft)]">
          No account?{" "}
          <Link to="/signup" className="text-blue-600 hover:underline" data-testid="link-signup">Start a 30-day free trial</Link>
        </div>
      </div>
    </div>
  );
}
